/* eslint-disable react/jsx-no-duplicate-props */
/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";
import MKInput from "../../../components/MKInput";
import MKButton from "../../../components/MKButton";

// i18n
import { useLanguage } from "i18n";

function ContactUs({ isThanks }) {
  const { t } = useLanguage();

  if (isThanks) {
    return (
      <MKBox component="section" pt={6} my={4}>
        <Container>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item sx={12} md={4} lg={4} sx={{ ml: { xs: 0, lg: 3 } }}>
              <MKTypography variant="h4">{t("contact.thanksTitle")}</MKTypography>
              <MKTypography variant="body2" color="text" mb={3}>
                {t("contact.thanksDescription")}
              </MKTypography>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
    );
  }

  return (
    <MKBox component="section" pt={6} my={4}>
      <Container>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item sx={12} md={8} lg={8} sx={{ ml: { xs: 0, lg: 3 } }}>
            <MKTypography variant="h4">{t("contact.title")}</MKTypography>
            <MKTypography variant="body2" color="text" mb={3}>
              {t("contact.description")}
            </MKTypography>
          </Grid>
          <Grid item sx={12} md={8} lg={8} sx={{ ml: { xs: 0, lg: 3 } }}>
            <form method="post" action="/submit">
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <MKInput
                    type="phonenumber"
                    label={t("contact.phone")}
                    id="phonenumber"
                    name="phonenumber"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <MKInput
                    type="email"
                    label={t("contact.email")}
                    id="email"
                    name="email"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <MKButton
                    variant="gradient"
                    color="info"
                    sx={{ height: "100%" }}
                    type="submit"
                    fullWidth
                  >
                    {t("contact.submit")}
                  </MKButton>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

ContactUs.propTypes = {
  isThanks: PropTypes.bool,
};

export default ContactUs;
